import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const StudentProfile = createAsyncThunk('student-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-student/profile`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentPayments = createAsyncThunk('student-payments', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-student/payments`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchedule = createAsyncThunk('get-schedule', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-student/get-schedule`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSemesters = createAsyncThunk('get-semesters', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-student/get-semesters`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetMarkSheet = createAsyncThunk('get-mark-sheet', async (_, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dua-student/get-mark-sheet`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetEvaluationQuestions = createAsyncThunk(
  'ev-questions',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-student/evaluation-questions`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeCourseEvForm = createAsyncThunk(
  'store-course-ev-form',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}dua-student/store-course-ev-form`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAttendance = createAsyncThunk('get-attendance', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dua-student/get-attendance`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const studentInvoiceStatistic = createAsyncThunk(
  'student-payments-student-invoice-statistic',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-student/student-invoice-statistic`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentNews = createAsyncThunk('student-news', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-student/my-news`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type studentPortalState = {
  errors: any
}

const initialState: studentPortalState = {
  errors: '',
}

export const StudentPortalSlice = createSlice({
  name: 'student-portal',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = StudentPortalSlice.actions
export default StudentPortalSlice.reducer
